<div class="hmn-row__align">
  <p class="hmn-color__primary hmn-margin__x2-right hmn-hidden__before-md">mcattaneo</p>
  <app-shared-profile-circle></app-shared-profile-circle>
</div>
